export function LogoMark({ size = "md" }: { size?: "sm" | "md" | "lg" | "xl" }) {
  const classes = {
    sm: "h-5 w-5",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  return (
    <div
      className={`rounded-full border border-primary/60 shadow-[0_0_18px_rgba(180,160,220,0.25)] ${classes[size]}`}
    />
  );
}
